module.exports = __webpack_public_path__ + "img/activity_other9.2d9c5cc8.jpg";